module.exports = __webpack_public_path__ + "src/assets/img/03_2art_3part_gallery.8db76a46.jpg";